import { DYNAMITE_LAUNCHER, DYNAMITE_LAUNCHERS } from '../config/dynamite';

/**
 * Which launcher this page load renders (DWEB-144).
 *
 * The constant in config/dynamite.js is the decision; the two overrides
 * below exist so the OTHER launcher can be exercised without a rebuild —
 * by the e2e suite (one project per launcher, playwright.config.js, which
 * sets the global from an init script before the bundle runs) and by a
 * person checking the avatar on a built site (`?launcher=avatar`). Read
 * once at mount, by DynaMiteWidget.js. It is the DEFAULT face: since
 * v6.6.1 (DWEB-146) the demo's sync toggle promotes the chosen head into
 * the launcher over either default, and sync off returns to it.
 *
 * This reads NOTHING from storage and writes nothing: the choice is per
 * page load, like the avatar selection itself (DynamiteAvatar.js). The
 * privacy policy enumerates every key the site stores, and this is not one.
 */
export function resolveDynamiteLauncher() {
  try {
    const fromQuery = new URLSearchParams(window.location.search).get('launcher');
    if (DYNAMITE_LAUNCHERS.includes(fromQuery)) return fromQuery;
    const fromGlobal = window.__dynamiteLauncher;
    if (DYNAMITE_LAUNCHERS.includes(fromGlobal)) return fromGlobal;
  } catch {
    // No window (a prerender pass) or a malformed search string: the constant.
  }
  return DYNAMITE_LAUNCHER;
}
